import styled from "styled-components"

export const Wrapper = styled.section`
  margin: 0 auto;
  padding: 30px 10px;
  width: 80%;
`

const Header = styled.h1`
  font-weight: bold;
`

export const HeaderOneText = styled(Header)`
  font-size: 24px;
  margin-bottom: 6px;
`

export const HeaderTwoText = styled(Header)`
  font-size: 20px;
  margin-bottom: 6px;
`

export const HeaderThreeText = styled(Header)`
  font-size: 16px;
  margin-bottom: 6px;
`

export const ParagraphText = styled.p`
  font-size: 14px;
  line-height: 1.6;
`